
export const testimonialsTwo = [
  {
    id: 1,
    author: "Prisha Yadav",
    position: "Medical Student",
    text: "It is no exaggeration to say this NEET Support experience was transformative–both professionally and personally. This counseling will long remain a high point of my life.",
  },
  {
    id: 2,
    author: "Anurag Gupta",
    position: "BDS Student",
    text: "NEET Support has helped me acquire valuable insights that have greatly enhanced my career prospects. The guidance is comprehensive and provided by industry experts.",
  },
  {
    id: 3,
    author: "Devansh Kathuria",
    position: "Aspiring Doctor",
    text: "I've been using NEET Support for several months now, and I'm impressed by the quality of the services. They cover all aspects of the NEET counseling process and are easy to follow.",
  },
  {
    id: 4,
    author: "Geetanjali Arora",
    position: "MBBS Student",
    text: "I highly recommend NEET Support for anyone looking to secure a medical seat. The platform is user-friendly, and the counselors are knowledgeable.",
  },
  {
    id: 5,
    author: "Arpit Mathur",
    position: "MBBS Student",
    text: "NEET Support has been a game-changer for me. The guidance was up-to-date and relevant, helping me secure a seat in my dream college.",
  },
  // Add more testimonial objects as needed
];

export const paginationImages = [
  "/assets/images/testimonials/1.jpg",
  "/assets/images/testimonials/2.jpg",
  "/assets/images/testimonials/3.jpg",
  "/assets/images/testimonials/4.jpg",
  "/assets/images/testimonials/5.jpg",
];

export const testimonialsTwoFour = [
  {
    id: 1,
    image: "assets/images/testimonials/1.webp",
    rating: 4.5,
    numRatings: 1991,
    text: "I achieved an impressive 692 rank in NEET last year, but I was heartbroken when I lost the opportunity to enter my dream medical college due to a misstep in the Second Round counselling process. Feeling lost and frustrated about my future, I came across NEET Support. It was a seamless experience using their Counselling portal, their tools such as Rank and College Predictor, Seat Matrix ect. handled the complicated counselling process for me, preventing me from repeating the same mistake. With this portal, I successfully navigated the counselling phase and secured a place at one of the top government medical colleges I had always dreamed of attending. ",
    name: "Priyesh Choudhary",
    profession: "Overcoming Counseling Pitfalls",
  },
  {
    id: 2,
    image: "assets/images/testimonials/2.webp",
    rating: 4.5,
    numRatings: 1991,
    text: "I felt completely lost in the intricate NEET counselling process. Although my score was satisfactory, I struggled with properly filling out my preferences and was anxious about potentially attending a lower-ranked college. That’s when I came across NEET Support. The priceless tools on their portal such as Seat Matrix and College Predictor meticulously guided me through each step of the counselling process, allowing me to prioritise my college preferences effectively. With their expert help, I successfully gained admission into a distinguished medical college that I had once considered unattainable.",
    name: "Nikunj Saxena",
    profession: "From Confusion to Confidence",
  },
  {
    id: 3,
    image: "assets/images/testimonials/4.webp",
    rating: 4.5,
    numRatings: 1991,
    text: "I have consistently excelled, but I was unsure if my NEET rank would be sufficient to enroll in my dream college. Feeling nervous, I turned to NEET Support for assistance. Their priceless counselling mentorship and advanced tools not only helped me achieve my top choice but also assisted me throughout the admission process without any difficulties. Thanks to NEET Support, I secured my desired spot and am thriving in my medical studies. Their constant support provided me with the confidence I needed to flourish.    ",
    name: "Kashish Dhanuka",
    profession: "Achieving Beyond Expectations",
  },
  {
    id: 4,
    image: "assets/images/testimonials/3.webp",
    rating: 4.5,
    numRatings: 1991,
    text: "After my initial attempt at NEET, I felt an overwhelming sense of disappointment. Due to a combination of mediocre counselling and my own uncertainties, I ended up choosing a college that was far beneath my aspirations. However, I was determined to turn things around and teamed up with NEET Support for my second try. This time around, the mentors offered me comprehensive guidance, assisting me with everything from making my choices to understanding the seat allocation process. As a result, I not only improved my rank but also gained admission to my ideal medical college! I am deeply thankful to NEET Support for their assistance.",
    name: "Rohan Parasrampuria",
    profession: "A Second Chance at Success",
  },
];
